var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventHand(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.906,
    height: 14.414,
    viewBox: "0 0 16.906 14.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32342",
    "data-name": "Group 32342",
    transform: "translate(-1378.119 -493.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3841",
    "data-name": "Path 3841",
    d: "M1402.534,505.27h-.43c-1.094,0-2.922-1.475-2.922-1.475",
    transform: "translate(-11.018 -5.014)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3842",
    "data-name": "Path 3842",
    d: "M1381.022,509.376s-1.633.552-2.4-.586c.436-.727,2.149-3.869,2.149-3.869l3.869-2.579,1.434.148",
    transform: "translate(0 -4.236)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3843",
    "data-name": "Path 3843",
    d: "M1379.714,520.353l2.34-1.139.942-1.129",
    transform: "translate(-0.587 -12.671)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3844",
    "data-name": "Path 3844",
    d: "M1387.659,503.265l6.341-7.309a.915.915,0,0,0-.039-1.252h0a.915.915,0,0,0-1.327.035l-7.573,8.555",
    transform: "translate(-3.452)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3845",
    "data-name": "Path 3845",
    d: "M1389.3,508.824v.86a1.367,1.367,0,0,1-1.29,1.29h-3.439a1.165,1.165,0,0,0-1.266,1.065c0,.727.406,1.084,1.266,1.084h3.009c.755.667,1.206,1.29,2.149,1.29h1.29a5.82,5.82,0,0,0,1.356-.306h0a4.535,4.535,0,0,1,1.223-.124h.43",
    transform: "translate(-2.509 -7.709)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2669",
    "data-name": "Rectangle 2669",
    width: 3.009,
    height: 7.308,
    transform: "translate(1391.516 499.395)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3846",
    "data-name": "Path 3846",
    d: "M1389.732,519.011v.086c0,.518.581.774,1.306.774h-.02a1.609,1.609,0,0,0,1.1-.328",
    transform: "translate(-5.955 -13.167)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3847",
    "data-name": "Path 3847",
    d: "M1385.277,519.44a1.059,1.059,0,0,0,.987.431h-.022c.622,0,1.1-.256,1.1-.774v-.086",
    transform: "translate(-3.567 -13.167)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3848",
    "data-name": "Path 3848",
    d: "M1380.415,517.916l-.269.307-.432,2.039",
    transform: "translate(-0.587 -12.581)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_564",
    "data-name": "Line 564",
    y1: 0.43,
    transform: "translate(1383.778 505.414)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventHand);
export default __webpack_public_path__ + "static/media/event-hand.63c0e21bcc797a3b53123a2ea88f692a.svg";
export { ForwardRef as ReactComponent };